module.exports = __webpack_public_path__ + "lp/img/modal_close_icn.84911560.svg";